/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-09-10 19:14:41
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2024-07-27 17:24:30
 * @FilePath: \vue-hepha-order\src\views\stock\queryConfig\QueryForm.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const ReturnQueryForm = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0px',
    formData:{},
    formField:[
        {
            // name:'order.orderSource', // 订单名称
            key:'order_name',
            type:'input',
            width:'200px',
            allowClear:true,
            placeholder:'order.orderName',
        },
        {
            // name:'order.orderSource', // mes出库单号
            key:'back_number',
            type:'input',
            width:'200px',
            allowClear:true,
            placeholder:'order.backNumber',
        },
        {
            // name:'order.deliverStatus', // 退货状态
            key:'status',
            type:'select',
            allowClear:true,
            width:'200px',
            optionToLocale:true,
            placeholder:'stock.returnStatus',
            options:[
                {
                    value:1,
                    label:'order.returning'
                },
                {
                    value:4,
                    label:'stock.outScanned'
                },
                {
                    value:2,
                    label:'order.returnSuccessful'
                },
                {
                    value:3,
                    label:'stock.cancelReturn2'
                },
            ]
        },
        {
            // name:'order.orderSource', // sku
            key:'sku',
            type:'select',
            width:'200px',
            allowClear:true,
            placeholder:'order.sku',
            options:[],
        },
        // {
        //     // name:'order.customerType', // 物流公司
        //     key:'back_courier_type',
        //     type:'select',
        //     allowClear:true,
        //     width:'260px',
        //     optionToLocale:true,
        //     placeholder:'order.courierType',
        //     options:[]
        // },
        {
            // name:'order.erpNo', // SO
            key:'erp_no',
            type:'input',
            allowClear:true,
            width:'200px',
            placeholder:'order.erpNo',
        },
        {
            // name:'order.customerType', // 客户
            key:'customer_id',
            type:'select',
            allowClear:true,
            width:'200px',
            placeholder:'order.customerName',
            options:[]
        },
        {
            // name:'order.customerType', // 备注
            key:'remark',
            type:'input',
            allowClear:true,
            width:'200px',
            placeholder:'order.instruction',
        },
                {
            // name:'order.deliverStatus', // 退货仓库
            key:'back_factory',
            type:'select',
            allowClear:true,
            width:'200px',
            optionToLocale:true,
            placeholder:'order.rollOverInventory',
            options:[
                {
                    value:'Maisach',
                    label:'Maisach'
                },
                {
                    value:'ZU',
                    label:'ZU'
                },
                {
                    value:'CWH',
                    label:'CWH'
                },
            ]
        },
        
        {
            // name:'order.customerType', // 创建人
            key:'create_by',
            type:'select',
            allowClear:true,
            width:'200px',
            placeholder:'order.createUser',
            options:[]
        },
        {
            // name:'order.customerType', // 物料类别
            key:'category_code',
            type:'select',
            allowClear:true,
            width:'200px',
            placeholder:'stock.categoryType',
            options:[]
        },
        {
            name:'', // 退货时间
            key:'back_timestamp',
            type:'dateRange',
            allowClear:true,
            width:'330px',
            placeholder1:'stock.planReturnStartDate',
            placeholder2:'stock.planReturnEndDate',
        },
        {
            name:'', // 退货实际到货时间
            key:'back_real_timestamp',
            type:'dateRange',
            allowClear:true,
            width:'330px',
            placeholder1:'stock.realReturnStartDate',
            placeholder2:'stock.realReturnEndDate',
        },
    ]
}


const ReturnEditForm = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'130px',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'order.courierType', // 物流公司
            key:'back_courier_type',
            type:'select',
            allowClear:true,
            disabled:false,
            width:'260px',
            options:[]
        },
        {
            name:'order.courierNo', // 物流单号
            key:'back_courier_no',
            type:'input',
            allowClear:true,
            disabled:false,
            width:'260px',
        },
        {
            name:'order.courierLink', // 物流链接
            key:'back_courier_url',
            type:'input',
            allowClear:true,
            disabled:false,
            width:'260px',
        },
        {
            name:'order.courierStatus', // 物流状态
            key:'back_courier_status',
            type:'select',
            allowClear:true,
            disabled:false,
            width:'260px',
            optionToLocale:true,
            options:[
                // {
                //     label:'order.unship',
                //     value:0,
                // },
                // {
                //     label:'order.plan',
                //     value:1,
                // },
                // {
                //     label:'order.partialShip',
                //     value:2,
                // },
                {
                    label:'order.shiped',
                    value:3,
                },
                // {
                //     label:'order.signedFor',
                //     value:4,
                // }
            ]
        },
        // {
        //     name:'stock.backReceiveDate', // 实际退货时间
        //     key:'back_real_time',
        //     type:'date',
        //     showTime:false,
        //     allowClear:true,
        //     width:'260px',
        //     marginLeft:'40px'
        // },
        {
            name:'stock.cargoFreight', // 运费
            key:'cargo_freight',
            type:'input',
            width:'260px',
            allowClear:true,
            prefix:true,
        },
    ]
}


ReturnQueryForm.formField.forEach(item=>{
    ReturnQueryForm.formData[item.key] = ''
})

ReturnEditForm.formField.forEach(item=>{
    ReturnEditForm.formData[item.key] = ''
})


export {
    ReturnQueryForm,
    ReturnEditForm,
}